import { render, staticRenderFns } from "./allowCreate-editor.vue?vue&type=template&id=12f73d48&scoped=true&"
import script from "./allowCreate-editor.vue?vue&type=script&lang=js&"
export * from "./allowCreate-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f73d48",
  null
  
)

export default component.exports